import { BaseSelect } from '@app/components';
import { paymentMethodApi } from '@app/store';
import { createColumnHelper } from '@tanstack/react-table';
import { IPaymentMethod } from '@app/common';
import React from 'react';
import { ResourceSelect, ResourceSelectProps } from '../ResourceSelect';

const columnHelper = createColumnHelper<IPaymentMethod>();

const columns = [
  columnHelper.accessor('name', {
    header: () => (
      <BaseSelect.ListHeaderItem width="100%">
        Nom
      </BaseSelect.ListHeaderItem>
    ),
    cell: (info) => (
      <BaseSelect.ListItemCol width="100%">
        <BaseSelect.ListItemText numberOfLines={1} bold>
          {info.getValue()}
        </BaseSelect.ListItemText>
      </BaseSelect.ListItemCol>
    ),
  }),
];

export const PaymentMethodSelect = ({ label = 'Moyens de paiement', ...props }: Omit<ResourceSelectProps<IPaymentMethod>, 'columns' | 'useQuery'>) => {
  return (
    <ResourceSelect
      label={label}
      columns={columns}
      useQuery={paymentMethodApi.useReadManyPaymentMethodsQuery}
      {...props}
    />
  );
};
